/* eslint indent: 0 */

import Backbone from 'backbone';

import _filter from 'lodash/filter';

import UploadProgressItem from 'zoomforth_media_library/views/media_library.upload_progress_item.js';

import { NoSyncMixin } from 'zoomforth_zfutils/backbone_no_sync_model_mixin.js';
import zfModernHelpers from 'zoomforth_tools/modern_helpers.js';

import { getFirebaseEventHub } from 'zoomforth_zf/appglobals/firebase-event-hub.js';

const MediaLibraryUploadTracker = Backbone.Model.extend({
  ...NoSyncMixin,

  /* 
   * This model keeps track of "uploads" into the media library, which now includes
   * not just browser uploads, but video recordings as well. This view is how we persist
   * the progress view item which displays either an upoad percentage or the word "loading..." 
   * as an uploaded asset is being processed and made ready to use. 
   *
   * Each upload item that this view keeps track of has two components, a progressView instance, and
   * a "precursor" model. In the case of normal uploads, the precursor is an actual asset precursor. 
   */ 
  
  initialize: function(options){
    this.uploads = [];
    this.parentView = options.parent;
    
    this._bindUploader(options.uploader);
  },
  
  _bindUploader: function(uploader){
    var me = this;
    uploader.off();
    uploader.on({
      'submit': (uploadData)=> {
        me.submitUpload(uploadData);
      },
      'progress': (uploadData)=> {
        uploadData.progressView.trigger('progress', uploadData.percent);
      },
      'uploaded': (uploadData, asset)=>{
        me.resolveUpload(uploadData, asset);
      },
      'failed-upload': (uploadData)=> {
        me.failUpload(uploadData);
      }
    });
    
  },
  
  getUploadsInFolder: function(folderId){
    var me = this;
    var uploads = _filter(this.uploads, function(upload){
      return me.getParentFolderOfUpload(upload) == folderId;
    });
    return uploads;
  },
  
  getParentFolderOfUpload: function(upload) {
    return upload.precursor.get('folder_id'); 
  }, 
  
  removeUploadByPrecursorId: function(precursorId){
    var filteredUploads = _filter(this.uploads, function(upload){
      return upload.precursor.get('id') != precursorId;
    });
    this.uploads = filteredUploads;
  },
  
  removeUploadByVideoId: function(videoId) {
    var filteredUploads = _filter(this.uploads, function(upload) {
      return (upload.precursor.video_asset_id != videoId);
    });
    this.uploads = filteredUploads;
  },
  
  getProgressViewByVideoId: function(videoId) {
    var progressView = false; 
    var upload = _filter(this.uploads, function(upload) {
      return (upload.precursor.video_asset_id == videoId); 
    });
    if (upload.length) {
      progressView = upload[0].progressView;
    }
    return progressView; 
  },
  
  submitUpload: function(uploadData){
    uploadData.progressView = new UploadProgressItem({
      model: uploadData.precursor
    });
    this.uploads.push(uploadData);
    this.trigger('upload-submitted', uploadData);
  },
  
  resolveUpload: function(uploadData, asset){
    var me = this;
    
    var triggerResolution = function(){
      asset.save({
        parent_folder_id: uploadData.precursor.get('folder_id')
      }, {silent: true, patch: true}).done(function(){
        me.removeUploadByPrecursorId(uploadData.precursor.get('id'));      
        me.trigger('upload-complete', uploadData, asset);
      });
    };        

    if (asset.get('assetType') === 'video'){
      me.initializeFirebaseListener(asset, 'video-processed', triggerResolution);

    } else if (asset.get('assetType') === 'ppt') {
      me.initializeFirebaseListener(asset, 'ppt-processed', triggerResolution);

    } else if (asset.get('assetType') === 'html_package') {
      me.initializeFirebaseListener(asset, 'html-package-processed', triggerResolution);

    } else {
      triggerResolution();

    }
  },
  
  failUpload: function(uploadData){
    if (uploadData.precursor.get('error')) {
      zfModernHelpers.alert('Something went wrong with an upload. ' + uploadData.precursor.get('error'));
    }
    if (typeof uploadData.progressView !== 'undefined') {
      uploadData.progressView.remove();
    }
    this.trigger('upload-failed', uploadData);
    this.removeUploadByPrecursorId(uploadData.precursor.get('id'));
  },

  initializeFirebaseListener: function(asset, firebaseEventString, onResolution) {
    var me = this;
    var updateAfterEncoded = function(assetId){
      if (asset.get('assetId') === assetId) {
        onResolution();
        me.stopListening(getFirebaseEventHub(), firebaseEventString, updateAfterEncoded);
      }
    };
    me.listenTo(getFirebaseEventHub(), firebaseEventString, updateAfterEncoded);
  }
    
});

export default MediaLibraryUploadTracker;
